import { createSlice } from "@reduxjs/toolkit";
import { exerciseApi } from "../api/exerciseApi";
import { Exercise } from "@nicsmith/shared_types";
import i18n from "i18next";

interface ExerciseState {
  exercises: Exercise[] | null;
  loading: boolean;
  error: string | null;
  showResult: boolean;
}

const initialState: ExerciseState = {
  exercises: null,
  loading: true,
  error: null,
  showResult: false,
};

const exerciseListSlice = createSlice({
  name: "exerciseList",
  initialState,
  reducers: {
    showResults: (state) => {
      state.showResult = true;
    },
    resetExercise: (state) => {
      state.showResult = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        exerciseApi.endpoints.getAllExercises.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
          state.exercises = null;
        }
      )
      .addMatcher(
        exerciseApi.endpoints.getAllExercises.matchFulfilled,
        (state, action) => {
          state.exercises = action.payload;
          state.loading = false;
          state.error = null;
          state.showResult = false;
        }
      )
      .addMatcher(
        exerciseApi.endpoints.getAllExercises.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message || i18n.t("errors.failedToFetchExercises", "Failed to fetch exercises");
        }
      );
  },
});

export const { showResults, resetExercise } =
  exerciseListSlice.actions;

export default exerciseListSlice.reducer;
